import React, { Component } from "react";
import { RenderTabuRequiredDocuments, ReqTabuDoc, TabuDoc } from "../TabuRequest/BaseTabuRequestForm";
import { DNRDModelX } from "./utils";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { populateTabuLookUp, TabuLookUp } from "@my-dld/tabuapi";
import Strings from "@my-dld/assets/strings";
import { TabuDocumentRequest, TabuRequestApi } from "@10x/tabu-mobile-api";

interface State {
	isGGC: boolean;
	docs: ReqTabuDoc[];
	error?: string;
}

interface Props {
	data: DNRDModelX;
}

export class DocumentUpload extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isGGC: props.data?.IsGCCNational === true,
			docs: [],
		};
	}

	componentDidMount() {
		this.loadReqDocs();
	}

	public validate() {
		let isValid = true;
		const docs = this.state.docs;
		if ( docs == null )
			isValid = false;
		else {
			for ( let doc of docs ) {
				if ( doc.IsRequired && ( doc.docs == null || doc.docs.length === 0 ) )
					isValid = false;
			}
		}
		if ( !isValid ) {
			this.setState( {
				error: Strings.mandatory_fields_note,
			} );
		}
		return isValid;
	}

	uploadDocs(): Promise<TabuDocumentRequest[]> {
		const uploadedDoc: any[] = [];
		const reqDocs = this.state.docs;
		for ( let reqDoc of reqDocs ) {
			if ( reqDoc.docs && reqDoc.docs.length > 0 ) {
				for ( let tabuDoc of reqDoc.docs ) {
					if ( tabuDoc.localData ) {
						let extData = tabuDoc.localData.split( ";" )[ 0 ];
						let type = extData.includes( "image" ) ? "jpg" : "pdf";
						let encoded = tabuDoc.localData.replace( /^data:(.*;base64,)?/, "" );
						if ( ( encoded.length % 4 ) > 0 ) {
							encoded += "=".repeat( 4 - ( encoded.length % 4 ) );
						}
						uploadedDoc.push( TabuRequestApi.uploadTabuDocument( encoded, type ).then( ( response ) => {
								let remoteDoc: TabuDocumentRequest = {
									DocumentId: "" + reqDoc.Identity,
									DocumentPath: [ response.Response.FileName ]
								};
								return Promise.resolve( remoteDoc );
							} ).catch( ( reason ) => {
								return Promise.reject( reason );
							} )
						);
					}
				}
			}
		}
		return Promise.all( uploadedDoc );
	}

	render() {
		let { docs, error, isGGC } = this.state;
		return (
			<React.Fragment>
				<RenderTabuRequiredDocuments
					reqDocuments={ docs }
					onDropRejected={ this.onDropRejected }
					onDrop={ this.onDrop }
					onDelete={ this.onDelete }/>
				{ error && <div className="invalid-feedback invalid-feedback-x">
					{ error }
				</div> }
			</React.Fragment>
		);
	}

	private loadReqDocs() {
		const isGCC = this.state.isGGC;
		const lookUp = isGCC ? TabuLookUp.NATIONAL_PERSON_DOCUMENTS : TabuLookUp.RESIDENT_PERSON_DOCUMENTS;
		showLoading();
		populateTabuLookUp( lookUp, this, ( docs?: ReqTabuDoc[] ) => {
			this.setState( {
				docs: docs ?? [],
			}, () => {
				hideLoading();
			} );
		} );
	}

	private onDropRejected = () => {
		showErrorMessage( Strings.tabu_file_exceed_size );
	};

	private onDrop = ( doc: ReqTabuDoc, files: File[] ) => {
		this.setState( {
			error: undefined,
		} );
		if ( doc.MaxPages > 1 ) {
			if ( doc.docs && doc.docs.length > 0 ) {
				let maxAllowed = ( doc.MaxPages - doc.docs.length );
				if ( files.length > maxAllowed )
					files = files.splice( 0, maxAllowed );
			} else if ( files.length > doc.MaxPages ) {
				files = files.splice( 0, doc.MaxPages );
			}
		}
		files.forEach( ( file ) => {
			if ( file.type.startsWith( "image/" ) || file.type.startsWith( "application/pdf" ) ) {
				this.addFile( doc, file );
			}
		} );
	};

	private addFile( reqTabuDoc: ReqTabuDoc, file: File ) {
		const reader = new FileReader();
		reader.onload = () => {
			const binaryStr = reader.result;
			const tabuDoc: TabuDoc = {
				identity: reqTabuDoc.Identity,
				localData: binaryStr as string,
				fileName: file.name,
				fileSize: file.size,
				type: file.type,
			};
			if ( reqTabuDoc.MaxPages > 1 ) {
				if ( reqTabuDoc.docs == null ) {
					reqTabuDoc.docs = [];
				}
			} else {
				reqTabuDoc.docs = [];
			}
			reqTabuDoc.docs.push( tabuDoc );
			this.setState( s => {
				return {
					docs: s.docs.map( ( doc: ReqTabuDoc ) => {
						return ( reqTabuDoc.Identity === doc.Identity ) ? { ...doc, docs: reqTabuDoc.docs } : doc;
					} )
				};
			} );
		};
		reader.readAsDataURL( file );
	}

	private onDelete = ( identity: number, index: number ) => {
		this.setState( {
			error: undefined,
		} );
		this.setState( s => {
			return {
				docs: s.docs.map( ( doc: ReqTabuDoc ) => {
					if ( doc.Identity === identity ) {
						if ( doc.docs && doc.docs.length > 0 ) {
							doc.docs.splice( index, 1 );
						}
						return doc;
					}
					return doc;
				} )
			};
		} );
	};
}
